import React from "react";

const Cuoricini = ({ likes }) => {
  if (likes <= 0) return null; // Mostra il cuoricino solo se likes > 0

  return (
    <div style={{ position: "relative", display: "inline-block", fontSize: "16px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="1em"
        viewBox="0 0 512 512"
        fill="#ff4d4d"
        style={{ width: "1.5em", height: "1.5em" }}
      >
        <path d="M462.3 62.7c54.5 54.2 54.6 142.3 0 196.6l-193.1 192.3-192.3-192.3C1.4 205.1 1.3 117 55.8 62.7 110.3 8.4 198.3 8.4 252.8 62.7L256 65.9l3.2-3.2c54.5-54.2 142.5-54.2 196.1 0z" />
      </svg>
      <span
        style={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          color: "#fff",
          fontSize: "0.75em",
          fontWeight: "bold",
        }}
      >
        {likes}
      </span>
    </div>
  );
};

export default Cuoricini;